// Dedicated add-to-cart handler for the "Zusätzliche Angebote" cross-sell
// offer on the cart page. Deliberately NOT built on the shared <product-form>
// custom element: that element publishes a global cartUpdate event, which
// <cart-items> (this same section's own wrapper) is subscribed to — and
// reacting to it re-renders the very block the event came from. That
// self-referential update caused a runaway loop of repeated /cart/add calls.
// This handler updates the DOM itself, once, with no pub/sub involved.
document.addEventListener('submit', function (evt) {
  var form = evt.target;
  if (!form.classList || !form.classList.contains('wk-cross-sell-form')) return;

  evt.preventDefault();
  if (form.dataset.submitting === 'true') return;
  form.dataset.submitting = 'true';

  var button = form.querySelector('[type="submit"]');
  var spinner = form.querySelector('.loading__spinner');
  if (button) button.setAttribute('aria-disabled', 'true');
  if (spinner) spinner.classList.remove('hidden');

  var mainCartItemsEl = document.getElementById('main-cart-items');
  var replacements = [
    { id: 'main-cart-items', section: mainCartItemsEl ? mainCartItemsEl.dataset.id : null, selector: '.js-contents' },
    { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
  ].filter(function (section) {
    return !!section.section;
  });

  var formData = new FormData(form);
  formData.append(
    'sections',
    replacements.map(function (section) {
      return section.section;
    })
  );
  formData.append('sections_url', window.location.pathname);

  var config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  fetch(routes.cart_add_url, config)
    .then(function (response) {
      return response.json();
    })
    .then(function (response) {
      if (response.status) {
        console.error('Cross-sell add to cart failed:', response.description || response.message);
        return;
      }
      if (!response.sections) return;

      replacements.forEach(function (section) {
        var html = response.sections[section.section];
        if (!html) return;
        var container = document.getElementById(section.id);
        if (!container) return;
        // cart-icon-bubble / cart-live-region-text render inline in the page
        // without their own ".shopify-section" wrapper (only the isolated
        // section-rendering response has one) — fall back to the container
        // itself, same as cart.js's own updateQuantity()/onCartUpdate() do.
        var target = container.querySelector(section.selector) || container;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var source = parsed.querySelector(section.selector);
        if (source) target.innerHTML = source.innerHTML;
      });
    })
    .catch(function (e) {
      console.error(e);
    })
    .finally(function () {
      delete form.dataset.submitting;
      if (button) button.removeAttribute('aria-disabled');
      if (spinner) spinner.classList.add('hidden');
    });
});
